var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsBoolean, IsEnum, IsOptional, IsString, IsUUID } from 'class-validator';
import { Role } from '../../roles/index.js';
export class UserProfileDto {
    id;
    keycloakId;
    firstName;
    lastName;
    officeId;
    get fullName() {
        return `${this.firstName} ${this.lastName}`;
    }
    salutation;
    profileImage;
    isArchived;
    role;
}
__decorate([
    Expose(),
    IsOptional(),
    IsUUID(),
    __metadata("design:type", String)
], UserProfileDto.prototype, "id", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsUUID(),
    __metadata("design:type", String)
], UserProfileDto.prototype, "keycloakId", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], UserProfileDto.prototype, "firstName", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], UserProfileDto.prototype, "lastName", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsUUID(),
    __metadata("design:type", String)
], UserProfileDto.prototype, "officeId", void 0);
__decorate([
    IsString(),
    Expose({ groups: [Role.ADMIN, Role.MANAGEMENT, Role.THERAPIST] }),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], UserProfileDto.prototype, "fullName", null);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], UserProfileDto.prototype, "salutation", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], UserProfileDto.prototype, "profileImage", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], UserProfileDto.prototype, "isArchived", void 0);
__decorate([
    Expose(),
    IsEnum(Role),
    __metadata("design:type", String)
], UserProfileDto.prototype, "role", void 0);
//# sourceMappingURL=user.profile.dto.js.map